import {
    cleanCommonParams,
    mapPlatformStatesParams,
} from './common';

const mapPlatformParams = (
    isCreate,
    {
        name,
        states,
        products,
        platform_states,
        use_product_state_availability, // eslint-disable-line no-unused-vars -- omitted; developer-only via PlatformData
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            platform: {
                ...cleanCommonParams(params),
                ...mapPlatformStatesParams(isCreate, platform_states),
            },
        });
    });
};

export { mapPlatformParams };
